// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CaseStudy_wrapper__1gtUf","case_wrapper":"CaseStudy_case_wrapper__1FAWc","inner":"CaseStudy_inner__320h5","autoSlider":"CaseStudy_autoSlider__3Sxaw"};